import { render, staticRenderFns } from "./ThgInsuranceCheck.vue?vue&type=template&id=704dcfd9"
import script from "./ThgInsuranceCheck.vue?vue&type=script&lang=ts"
export * from "./ThgInsuranceCheck.vue?vue&type=script&lang=ts"
import style0 from "./ThgInsuranceCheck.vue?vue&type=style&index=0&id=704dcfd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VRow})
